import { BcAntenatalRadioTextboxField } from "../BcAntenatalRadioTextboxField";
import { PresentPregnancyAssistedReproductiveTechnology } from "./PresentPregnancyAssistedReproductiveTechnology";

class BritishColumbiaObstetricalFilePresentPregnancy {
    public Bleeding: BcAntenatalRadioTextboxField;
    public Nausea: BcAntenatalRadioTextboxField;
    public Traveled: BcAntenatalRadioTextboxField;
    public Infection: BcAntenatalRadioTextboxField;
    public Other: BcAntenatalRadioTextboxField;
    public AssistedReproductiveTechnology: PresentPregnancyAssistedReproductiveTechnology;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFilePresentPregnancy>) {
        Object.assign(this, fields);
        this.AssistedReproductiveTechnology = new PresentPregnancyAssistedReproductiveTechnology(fields?.AssistedReproductiveTechnology);
        this.Bleeding = new BcAntenatalRadioTextboxField(fields?.Bleeding);
        this.Nausea = new BcAntenatalRadioTextboxField(fields?.Nausea);
        this.Traveled = new BcAntenatalRadioTextboxField(fields?.Traveled);
        this.Infection = new BcAntenatalRadioTextboxField(fields?.Infection);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
    }

    public setEmptyFieldsAsNo(): void {
        this.Bleeding.Value ||= false;
        this.Nausea.Value ||= false;
        this.Traveled.Value ||= false;
        this.Infection.Value ||= false;
        this.Other.Value ||= false;
        this.AssistedReproductiveTechnology.HasAssistedReproductiveTechnology ||= false;
    }
}

export { BritishColumbiaObstetricalFilePresentPregnancy };
